import axios from "axios";
const baseurl = process.env.REACT_APP_API_URL;

export const getFeaturedAdds = async () => {
  const res = await axios({
    method: "get",
    url: baseurl + `/featuredAds`,
  });
  return res.data.data;
};
